import { UnderMinimumWinnings } from '../general/under-minimum-winnings';
import { PreCheckErrorMixin } from './pre-check-error';

export class UnderMinimumWinningsPreCheckError extends PreCheckErrorMixin(UnderMinimumWinnings) {
    constructor() {
        super();
    }
}
